export default function getEnvironment() {
  const host = document.location.hostname;

  switch (host) {
    case 'assets.movableink-templates.com':
      return 'production';
    case 'assets-staging.movableink-templates.com':
      return 'staging';
    default:
      return 'development';
  }
}
